(() => {
  'use strict';

  const cardSelector = '.oke-reviewCarousel .oke-reviewCard.oke-reviewCard--below';

  function reorderCard(card) {
    const children = [...card.children];
    const head = children.find((child) => child.classList.contains('oke-reviewCard-head'));
    const content = children.find((child) => child.classList.contains('oke-reviewCard-content'));
    if (!head || !content || children.indexOf(content) < children.indexOf(head)) return;

    // Match the vendor's existing visual order without changing another card layout.
    if (!['flex', 'inline-flex'].includes(getComputedStyle(card).display) ||
        getComputedStyle(head).order !== '4' || getComputedStyle(content).order !== '0') return;

    const active = document.activeElement;
    const preserveFocus = content.contains(active);
    card.insertBefore(content, head);
    if (preserveFocus && document.activeElement !== active) active.focus({ preventScroll: true });
  }

  function collectCards(root, cards) {
    if (root.nodeType !== 1) return;
    const parentCard = root.closest(cardSelector);
    if (parentCard) cards.add(parentCard);
    root.querySelectorAll(cardSelector).forEach((card) => cards.add(card));
  }

  function start() {
    document.querySelectorAll(cardSelector).forEach(reorderCard);
    new MutationObserver((mutations) => {
      const cards = new Set();
      mutations.forEach((mutation) => {
        collectCards(mutation.target, cards);
        mutation.addedNodes.forEach((node) => collectCards(node, cards));
      });
      cards.forEach(reorderCard);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  window.addEventListener('load', () => document.querySelectorAll(cardSelector).forEach(reorderCard), { once: true });
})();
